export default function AppBackground({ style }) {
  return <div className="pj-bg-pattern" aria-hidden="true" style={style} />;
}
